import {
  ListMask,
  useScrollableMask,
} from '@euler/app/components/list/ListMask';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Pressable, ScrollView } from 'react-native';
import { TagBadge } from './TagBadge';

type Props = {
  tags: string[];
  onPress?: () => void;
};

export const TagScrollView = memo(({ tags, onPress }: Props) => {
  const { rpx } = useResponsiveContext();
  const {
    showLeadingMask,
    showTrailingMask,
    onLayout,
    onContentSizeChange,
    onScroll,
  } = useScrollableMask({ orientation: 'horizontal' });

  return (
    <ListMask
      leadingMask={showLeadingMask}
      trailingMask={showTrailingMask}
      location={0.06}
      css={`
        flex: 1;
      `}
    >
      <ScrollView
        horizontal
        keyboardShouldPersistTaps="handled"
        showsHorizontalScrollIndicator={false}
        scrollEventThrottle={16}
        onLayout={onLayout}
        onContentSizeChange={onContentSizeChange}
        onScroll={onScroll}
        contentContainerStyle={{
          flexGrow: 1,
          alignItems: 'center',
          paddingRight: rpx(2),
        }}
      >
        {tags.map(tag => (
          <Pressable key={tag} onPress={onPress}>
            <TagBadge key={tag} label={tag} />
          </Pressable>
        ))}
        {/* Tap target for the empty trailing area: with few tags it expands
              (flexGrow on the content container makes the row at least the
              viewport width) so a tap there opens the card; with many tags it
              collapses to ~0, leaving the strip fully scrollable. */}
        {onPress ? (
          <Pressable
            onPress={onPress}
            style={{ flex: 1, alignSelf: 'stretch' }}
          />
        ) : null}
      </ScrollView>
    </ListMask>
  );
});
